import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import { ReactComponent as CalBlue } from "./Assets/icon_calendar_blue.svg";
import { ReactComponent as CalGreen } from "./Assets/icon_calendar_green.svg";
import { ReactComponent as DiplBlue } from "./Assets/icon_diplom_blue.svg";
import { ReactComponent as DiplYellow } from "./Assets/icon_diplom_yellow.svg";
import { ReactComponent as PhoneBlue } from "./Assets/icon_phone_blue.svg";
import { ReactComponent as PhoneYellow } from "./Assets/icon_phone_yellow.svg";
import { ReactComponent as SchoolBlue } from "./Assets/icon_scholl_blue.svg";
import { ReactComponent as SchoolGreen } from "./Assets/icon_scholl_green.svg";
import React from 'react'
import { theme } from "../../App";
import { NAVBAR_SPACE } from "../Navbar/Navbar";
import { highlightColor } from "../../Classes/theme";
import { Motion } from "../Motion/Motion";

const images = [[<PhoneYellow />, <PhoneBlue />],
[<SchoolBlue />, <SchoolGreen />],
[<CalBlue />, <CalGreen />],
[<DiplYellow />, <DiplBlue />]];

const texts = [{ title: 'Aplikace', text: <>Studujte kdykoliv<br />a kdekoliv</> },
{ title: 'Efektivní studium', text: 'Ulehčete si práci studijními módy' },
{ title: 'Aktuální otázky', text: 'Studujte otázky, které u zkoušek potkáte' },
{ title: 'Úspěch u zkoušek', text: 'S námi zkoušky zvládnete snadno' },]

export default function Advantages({ advantages = [0, 0, 0, 0] }) {
    const removeOne = useMediaQuery("(max-width:1000px)");
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));

    return (
        <Box sx={{ py: { xs: '80px', sm: '60px', md: '40px' }, bgcolor: highlightColor, display: 'flex', flexDirection: 'row' }}>
            <Container maxWidth='lg' sx={{ px: NAVBAR_SPACE, display: 'flex', flexDirection: 'row', justifyContent: "center", alignItems: "stretch", flexWrap: 'wrap' }}>
                {advantages.map((i, j) => {
                    let flexBasis = "auto";
                    let mb = '0';
                    if (!mobile && removeOne) {
                        if (j === 0 || j === 1) {
                            mb = '40px'
                        }
                        flexBasis = "50%";
                    } else if (mobile) {
                        flexBasis = "100%";
                        if (j !== advantages.length - 1) {
                            mb = "50px";
                        }
                    }
                    return <Box key={"Advantage" + j} sx={{ mb, flex: 1, flexBasis, display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center', justifyContent: 'top' }}>
                        <Motion scale={1.03}><Box>{images[j][i]}</Box></Motion>
                        <Typography variant='medium' sx={{}}>{texts[j].title}</Typography>
                        <Typography sx={{ maxWidth: '155px', mt: '8px' }}>{texts[j].text}</Typography>
                    </Box>
                })}
            </Container>
        </Box>
    )
}
